const CONFIG = {
    API_ENDPOINT: process.env.REACT_APP_BASE_URL,
    REQUEST_TIMEOUT: process.env.REACT_APP_REQUEST_MAX_TIMEOUT,
    PUBLIC_KEY: process.env.REACT_APP_DASHBOARD_ADMIN_PUBLIC_KEY,
    BITESHIP_API_ENDPOINT: process.env.REACT_APP_BITESHIP_API_ENDPOINT,
    BITESHIP_KEY: process.env.REACT_APP_BITESHIP_KEY,
    GOOGLE_RECAPTCHA_SITE_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
}

export default CONFIG